import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DatastoreRoleField({
  value,
  type,
  error,
  setValue,
  setError,
  setChanged,
  edit,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (
      !/^arn:aws:iam::[0-9]{12}:role\/[a-zA-Z0-9+=,.@_-]{1,64}$/.test(newValue)
    ) {
      setError('Role must be a valid ARN');
    } else if (newValue === '') {
      setError('Role cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Role ARN'
          id='role'
          aria-describedby='role-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
        />
        {error ? (
          <FormHelperText id='role-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='role-helper-text'>
            Enter the datastore role
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
